import { render, staticRenderFns } from "./CompanySettings.vue?vue&type=template&id=77b3a5f2&scoped=true&"
import script from "./CompanySettings.vue?vue&type=script&lang=js&"
export * from "./CompanySettings.vue?vue&type=script&lang=js&"
import style0 from "./CompanySettings.vue?vue&type=style&index=0&id=77b3a5f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b3a5f2",
  null
  
)

export default component.exports